<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <!-- Page Heading -->
            <div class="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 v-if="language == 'fr'" class="h3 mb-0 fw-bolder text-primary">Tableau de bord</h1>
              <h1 v-if="language == 'en'" class="h3 mb-0 fw-bolder text-primary">Dashboard</h1>
            </div>
            <hr class="clearfix">
            <div class="row p-0">
                <div class="col-md-3 mb-2">
                    <div class="card border-left-primary shadow h-100 py-2">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                  <div v-if="language == 'fr'" class="text-primary text-uppercase mb-1">Régions</div>
                                  <div v-if="language == 'en'" class="text-primary text-uppercase mb-1">Areas</div>
                                  <div class="h3 mb-0 font-weight-bold text-primary">{{ countAreas }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="card border-left-primary shadow h-100 py-2">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                  <div v-if="language == 'fr'" class="text-primary text-uppercase mb-1">Pays</div>
                                  <div v-if="language == 'en'" class="text-primary text-uppercase mb-1">Countries</div>
                                  <div class="h3 mb-0 font-weight-bold text-primary">{{ countCountries }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="card border-left-primary shadow h-100 py-2">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                  <div v-if="language == 'fr'" class="text-primary text-uppercase mb-1">Entreprises</div>
                                  <div v-if="language == 'en'" class="text-primary text-uppercase mb-1">Companies</div>
                                  <div class="h3 mb-0 font-weight-bold text-primary">{{ countCompanies }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="card border-left-primary shadow h-100 py-2">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                  <div v-if="language == 'fr'" class="text-primary text-uppercase mb-1">Sites</div>
                                  <div v-if="language == 'en'" class="text-primary text-uppercase mb-1">Sites</div>
                                  <div class="h3 mb-0 font-weight-bold text-primary">{{ countSites }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="card border-left-primary shadow h-100 py-2">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                  <div v-if="language == 'fr'" class="text-primary text-uppercase mb-1">Bussiness Units</div>
                                  <div v-if="language == 'en'" class="text-primary text-uppercase mb-1"> Bussiness Units</div>
                                  <div class="h3 mb-0 font-weight-bold text-primary">{{ countBussinessUnits }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="card border-left-primary shadow h-100 py-2">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                  <div v-if="language == 'fr'" class="text-primary text-uppercase mb-1">Evaluateurs</div>
                                  <div v-if="language == 'en'" class="text-primary text-uppercase mb-1">Assessors</div>
                                  <div class="h3 mb-0 font-weight-bold text-primary">{{ countAssessors }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="card border-left-primary shadow h-100 py-2">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                  <div v-if="language == 'fr'" class="text-primary text-uppercase mb-1">Utilisateurs</div>
                                  <div v-if="language == 'en'" class="text-primary text-uppercase mb-1">Users</div>
                                  <div class="h3 mb-0 font-weight-bold text-primary">{{ countUsers }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="card border-left-primary shadow h-100 py-2">
                        <div class="card-body">
                            <div class="row no-gutters align-items-center">
                                <div class="col mr-2">
                                  <div v-if="language == 'fr'" class="text-primary text-uppercase mb-1">Evaluations</div>
                                  <div v-if="language == 'en'" class="text-primary text-uppercase mb-1">Assessments</div>
                                  <div class="h3 mb-0 font-weight-bold text-primary">{{ countAssessments }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </div>
        </div>

        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@keyframes circle {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.odd {
    background-color: #f8f9fc;
}
.even {
    background-color: #ffffff;
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
import swal from 'sweetalert2';
window.Swal = swal;
$.fn.isValid = function () {
 return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      language: '',
      countAreas: 0,
      countCountries: 0,
      countCompanies: 0,
      countSites: 0,
      countBussinessUnits: 0,
      countAssessors: 0,
      countUsers: 0,
      countAssessments: 0
    }
  },
  mounted() {
    this.language = localStorage.getItem('std_language')
    setTimeout(async function() {
      await this.display()
    }.bind(this), 500);
  },
  methods: {
    async display() {
      $('#preloader').fadeIn()
      const areas = await axios.get(this.apiUrl + '/areas?_page=1&_limit=1', {headers: {'Authorization': `Bearer ${this.token}`}});
      this.countAreas = areas.headers['x-total-count'];
      const countries = await axios.get(this.apiUrl + '/countries?_page=1&_limit=1', {headers: {'Authorization': `Bearer ${this.token}`}});
      this.countCountries = countries.headers['x-total-count'];
      const companies = await axios.get(this.apiUrl + '/companies?_page=1&_limit=1', {headers: {'Authorization': `Bearer ${this.token}`}});
      this.countCompanies = companies.headers['x-total-count'];
      const sites = await axios.get(this.apiUrl + '/sites?_page=1&_limit=1', {headers: {'Authorization': `Bearer ${this.token}`}});
      this.countSites = sites.headers['x-total-count'];
      const bussinessUnits = await axios.get(this.apiUrl + '/business_units?_page=1&_limit=1', {headers: {'Authorization': `Bearer ${this.token}`}});
      this.countBussinessUnits = bussinessUnits.headers['x-total-count'];
      const assessors = await axios.get(this.apiUrl + '/assessors?_page=1&_limit=1', {headers: {'Authorization': `Bearer ${this.token}`}});
      this.countAssessors = assessors.headers['x-total-count'];
      const users = await axios.get(this.apiUrl + '/users?_page=1&_limit=1', {headers: {'Authorization': `Bearer ${this.token}`}});
      this.countUsers = users.headers['x-total-count'];
      const assessments = await axios.get(this.apiUrl + '/assessments?_page=1&_limit=1', {headers: {'Authorization': `Bearer ${this.token}`}});
      this.countAssessments = assessments.headers['x-total-count'];
      $('#preloader').fadeOut()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue